// REACT
import React from "react";

const useConsole = () => {
  const EASTER_EGG = `
 ██████╗       ██╗       ██████╗ 
██╔════╝       ██║       ██╔══██╗
██║         ████████╗    ██████╔╝
██║         ██╔═██╔═╝    ██╔══██╗
╚██████╗    ██████║      ██████╔╝
 ╚═════╝    ╚═════╝      ╚═════╝ 
 
 Welcome to Caleb and Brown, the world's leading cryptocurrency brokerage firm. If you are reading this, feel free to submit your resume at https://www.calebandbrown.com/careers. We want to hear from you ❤️
 `;

  React.useEffect(() => {
    console.log(EASTER_EGG);
  }, []);
};

export default useConsole;
